module.exports = __webpack_public_path__ + "img/mark_ps_sbrf.548b3dfb.png";